import AsyncValidator from 'async-validator'
import {assign, isArray, isFunction, isNull} from 'lodash'

let ERR_TAB_APINAME = null
let SUB_PATH = {} // 从对象路径
const REG = /tab-item_([^/]+)/

function getTab (path = '') {
  const result = path.match(REG)
  return result ? result[1] : null
}

// 获取rules
let getRules

// 校验
export async function validator ({mainRecord, subRelevance}) {
  ERR_TAB_APINAME = null
  SUB_PATH = {}
  let error = []
  getRules = _createRules(mainRecord.formData)
  // 主对象
  error = error.concat(await createdValidator(mainRecord))
  // 从对象
  error = error.concat(await processSub(subRelevance))
  return {error, errorTabApiName: ERR_TAB_APINAME}
}

// 当前字段是否显示
function _getPageShow (node, payload) {
  let {propsFn, props = {}} = node
  // pageShow属性
  if (isFunction(propsFn)) {
    props = assign({}, props, propsFn(payload))
  }
  return props
}

// 从对象处理
async function processSub (subRelevance = {}) {
  let subError = []
  const keys = Object.keys(subRelevance)
  for (let i = 0; i < keys.length; i++) {
    let key = keys[i]
    subError = subError.concat(await validatorSub(subRelevance[key], SUB_PATH[key], {key}))
  }
  return subError
}

async function validatorSub ({data, fieldMap}, path, {key}) {
  if (data.length === 0) {
    return []
  }
  let error = []
  for (let i = 0; i < data.length; i++) {
    const row = data[i]
    const rowError = await createdValidator({fieldMap, formData: row}, path)
    error = error.concat(rowError.map(v => Object.assign(v, {index: i, subObjectParamName: key})))
  }
  return error
}

// 获取规则 闭包注入formData
function _createRules (formData) {
  return ({ row, rowIndex, node }) => {
    const payload = { field: node, formData, row, rowIndex }
    const newProps = _getPageShow(node, payload)
    payload.newProps = newProps
    const { pageShow, required } = newProps
    if (pageShow) {
      let { ruleFn, rules = [] } = node
      if (isFunction(ruleFn)) {
        rules = rules.concat(ruleFn(payload) || [])
      }
      return rules.map(v => {
        let _v = isFunction(v) ? v(payload) : v
        _v.required = _v.required || required
        return _v
      })
    }
    return []
  }
}


// 便利字段Map创建规则
function createdValidator ({fieldMap, formData}, parentPath) {
  const rulesMap = {}
  const model = {}
  for (let key in fieldMap) {
    const node = fieldMap[key]
    // 如果该字段在页面中使用过
    if (node.__isUse) {
      const rules = getRules({node, row: formData})
      if (rules.length) {
        rulesMap[key] = rules
      }
      model[key] = _getValue(formData, key)
      // 传了 parentPath 代表从对象
      if (parentPath) {
        node.__path = `${parentPath}/${node.__path}`
      }
      // 从对象
    } else if (node?.isMasterRelation) {
      let _subRule = node?.rule || node?.rules?.[node.layoutApiName] || []
      model[key] = formData[key]
      if (_subRule.length) {
        rulesMap[key] = _subRule
      }
      SUB_PATH[key] = node.__path
    }
  }
  return _validator(model, rulesMap, fieldMap)
}

function _getValue (obj, stringKey) {
  let keys = stringKey.split('.')
  let data = obj
  for (let i = 0; i < keys.length; i++) {
    data = data?.[keys[i]] === undefined ? null : data?.[keys[i]]
  }
  return data
}

// 校验
function _validator (data, rulesMap, fieldMap) {
  return new Promise(resolve => {
    let _error = []
    let validator = new AsyncValidator(rulesMap)
    validator.validate(data, {firstFields: true}, (error) => {
      if (isArray(error)) {
        _error = error
        if (isNull(ERR_TAB_APINAME)) {
          for (let i = 0; i < _error.length; i++) {
            if (isNull(ERR_TAB_APINAME = getTab(fieldMap[_error[i].field].__path))) { break }
          }
        }
      }
      resolve(_error)
    })
  })
}

// // 删除 Tigger
// function _delTigger (arr = []) {
//   return arr.map((item) => {
//     delete item.trigger
//     return item
//   })
// }
